<template>
    <div class="modal-content">
        <div class="modal-header border-0 p-4">
            <modal-close />
            <div class="modal-title">
                <h2 v-text="'Włączanie usługi'" class="h3 pt-1 mb-0" />
            </div>
        </div>
        <page-preloader
            min-height="260px"
            v-if="serviceStatus === 'loading'"
        />
        <div v-else class="modal-body p-4 border-top">
            <div v-if="isDrs" class="flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-3">
                <strong>UWAGA!</strong>
                Pamiętaj, że usługa {{ service.name }} jest <strong>płatna</strong>.
            </div>
            <div class="c-service__basic row">
                <div class="col-3 d-md-flex d-none justify-content-center">
                    <router-link
                        :to="{
                            name: 'service',
                            params: { id: service.id }
                        }"
                    >
                        <img
                            v-if="service.graphics.smallIconMinioUrl"
                            :src="service.graphics.smallIconMinioUrl"
                            class="c-service__img img-fluid"
                        />
                        <a-icon
                            v-else
                            class="c-service__img text-primary"
                            icon="NoPhoto"
                        />
                    </router-link>
                </div>
                <div class="col-md-9 col-12">
                    <div class="d-flex align-items-center gap-0-5">
                        <div class="d-md-none d-block">
                            <router-link
                                :to="{
                                    name: 'service',
                                    params: { id: service.id }
                                }"
                            >
                                <img
                                    v-if="
                                        service.graphics.smallIconMinioUrl
                                    "
                                    :src="
                                        service.graphics.smallIconMinioUrl
                                    "
                                    class="c-service__imgSmall img-fluid"
                                />
                                <a-icon
                                    v-else
                                    class="c-service__imgSmall text-primary"
                                    icon="NoPhoto"
                                />
                            </router-link>
                        </div>
                        <div>
                            <h2 class="c-service__title">
                                <router-link
                                    :to="{
                                        name: 'service',
                                        params: { id: service.id }
                                    }"
                                >
                                    {{ service.name }}
                                </router-link>
                            </h2>
                            <p class="c-service__status" v-if="allShops">
                                Aktywujesz we
                                <strong>wszystkich</strong>
                                sklepach
                            </p>
                            <p class="c-service__status" v-else>
                                Aktywujesz w
                                <strong>
                                    {{ selectedShopIds.length }} z
                                    {{ subscriptions.length }}
                                </strong>
                                sklepach
                            </p>
                        </div>
                    </div>

                    <div
                        class="v-service__shoplist t-shops"
                        v-if="!allShops"
                    >
                        <div class="custom-checkbox mb-2">
                            <the-btn
                                text="Zaznacz wszystkie"
                                class="btn-outline-custom d-none d-sm-inline-flex"
                                :class="{
                                    'd-inline-flex': !allowSelectAll
                                }"
                                icon="CheckCorrect"
                                @click.native="selectAllShops(true)"
                            />
                            <the-btn
                                text="Odznacz wszystkie"
                                class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
                                :class="{ 'd-inline-flex': allowSelectAll }"
                                icon="CheckIncorrect"
                                @click.native="selectAllShops(false)"
                            />
                        </div>
                        <service-shop
                            v-for="(shop, idx) in subscriptions"
                            :key="idx"
                            :shop="shop"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer d-block">
            <div
                class="c-service__legal"
                v-if="serviceStatus !== 'loading'"
            >
                <p v-if="service.code === 'pp_ms'" class="c-service__clause text-muted">
                    Administratorem Pani/Pana danych osobowych jest Eurocash
                    Sieci Partnerskie Sp. z o.o. z siedzibą w Komornikach
                    (62-052) przy ul. Wiśniowej 11.
                    <span
                        class="c-service__showMore cursor-pointer"
                        :class="{ 'show': !showInformationClause }"
                        @click="showInformationClause = !showInformationClause"
                    >
                        CZYTAJ WIĘCEJ...
                    </span>
                    <span
                        class="c-service__more"
                        :class="{ 'hidden': !showInformationClause }"
                    >
                        Podane przez Panią/Pana dane osobowe przetwarzane będą w celu
                        realizacji usług Powszechnego Towarzystwa Promocyjnego M/Sklepy,
                        w tym dokonywania rozliczeń z tytułu świadczonych usług oraz z
                        tytułu wykorzystanych promocji, dokonywania rozliczeń podatkowych,
                        rozpatrywania reklamacji oraz do dochodzenia lub obrony przed
                        roszczeniami, a w przypadku wyrażenia zgody marketingowej, w celu
                        przesyłania wiadomości marketingowych o promocjach dostępnych na
                        EuroPlatform. Zgodę można wycofać w każdym czasie. Wycofanie zgody
                        nie ma wpływu na zgodność z prawem przetwarzania dokonanego przed jej
                        wycofaniem. Pełna informacja o przetwarzaniu danych osobowych jest
                        dostępna
                        <a
                            class="text-primary"
                            target="_blank"
                            :href="informationClausePath"
                        >
                            TUTAJ
                        </a>.
                        <span
                            class="c-service__showLess cursor-pointer text-primary"
                            :class="{ 'show': showInformationClause }"
                            @click="showInformationClause = !showInformationClause"
                        >
                            Zwiń
                        </span>
                    </span>
                </p>
                <div v-if="isDrs" class="c-service__legalDiclamer text-primary d-flex align-items-center">
                    <ui-checkbox-input
                        v-model="drsConsent"
                        required
                        name="drsConsent"
                    >
                        Zapoznałem (-am) się z&nbsp;
                        <a
                            v-text="'Regulaminem'"
                            :href="regulationPath"
                            class="text-primary text-underline"
                            target="_blank"
                        />
                        &nbsp;usługi {{ service.name }} i akceptuję jego treść.
                    </ui-checkbox-input>
                </div>
                <p v-else class="c-service__legalDiclamer text-primary">
                    Aktywując usługę oświadczam, iż zapoznałem się z
                    załącznikami i akceptuję ich treść.
                </p>

                <ul v-if="!isDrs" class="v-service__documentList pl-3 mb-0">
                    <li v-for="(file, idx) in service.documents" :key="idx">
                        <a
                            class="v-service__link"
                            target="_blank"
                            :href="file.minioUrl"
                        >
                            <a-icon
                                style="min-width: 24px;"
                                icon="Download"
                            />
                            <span class="v-service__documentName text-sm">
                                {{ file.name }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="modal-footer__btnWide">
                <button
                    v-text="'Zamknij'"
                    class="btn btn-outline"
                    :disabled="status === 'loading'"
                    @click="closeModal"
                />
                <the-btn
                    type="button"
                    class="btn-secondary"
                    :disabled="isActivateDisabled"
                    @click="activateShops(!!allShops)"
                >
                    {{ allShops ? 'Włącz usługę we wszystkich sklepach' : 'Włącz usługę' }}

                    <button-spinner
                        class="ml-3"
                        :status="status"
                    />
                </the-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { registerPageModule } from '@/utils/store'
import store from '@/store'
import cloneDumb from '@/helpers/cloneDumb'
import ServiceShop from '@/components/services/ServiceShop'
import DrsStore, { SERVICE_CODE } from '@/store/modules/drs/drs.module'

export default {
    data() {
        return {
            status: 'idle',
            showInformationClause: false,
            drsConsent: false
        }
    },
    components: {
        ServiceShop
    },
    methods: {
        closeModal() {
            if (this.status === 'loading') return
            this.$store.dispatch('toggleModal', false)
        },
        async activateShops(value) {
            if (this.status === 'loading') return
            let shopIds = []
            this.status = 'loading'

            if (
                this.service.level !== 'User' &&
                this.service.level !== 'Company'
            ) {
                shopIds = value
                    ? this.$store.getters.getAllServiceShopIds
                    : this.$store.getters.getToActiveServiceShopIds
            }

            // activateDrsService and go to summary modal
            if (this.isDrs) {
                this.activateDrsService(shopIds, value)
                return
            }

            await this.$store.dispatch('serviceActivate', {
                serviceId: this.service.id,
                serviceCode: this.service.code,
                shopIds,
                allShops: value,
                level: this.service.level,
                singleService: this.args.singleService
            })
            this.status = 'idle'
            if (this.service.code === 'pp_ms' && !this.args.singleService) {
                // Check if all shopIds belong to the GAMA network — skip showing ConsentsModal
                const locationsByNetwork = this.$store.getters.getLocationsByNetworkAlias('GAMA')
                const allShopsInGamaNetwork = shopIds.every(id =>
                    locationsByNetwork?.some(location => location.value === id)
                )
                if (!allShopsInGamaNetwork) {
                    this.$store.dispatch('consentsFetch')
                    this.$store.dispatch('openModal', {
                        component: 'ConsentsModal',
                        args: {
                            consentCode: 'ECSP',
                            hideConsentDetails: true
                        }
                    })
                }
            }
        },
        selectAllShops(value) {
            const subscriptions = this.service.subscriptions.map(el => {
                if (el.status === 'inactive') {
                    return {
                        ...el,
                        checked: value
                    }
                } else {
                    return el
                }
            })
            this.$store.dispatch('setService', {
                ...this.service,
                subscriptions
            })
        },
        async activateDrsService(shopIds) {
            if (!this.$store.getters.drsData) {
                return
            }

            await this.$store.dispatch('fetchKplCompany')
            await registerPageModule(store, DrsStore, 'drs')
            await this.$store.dispatch('drs/loadDataAndCheckPermission')

            if (this.$store.getters.drsData.login && !this.$store.getters.isDrsLoginMatched) {
                // Show login error if NIP is matched but login is not
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/service/LoginError'
                })
                return
            }

            if (this.$store.getters.isKplCompanyDebt) {
                // Show debt warning if KPL company is dept
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/service/DebtWarning'
                })
                return
            }

            const replicatedLocations = this.$store.getters.replicatedLocationsByEpId
            const hasUnreplicatedLocations = this.$store.getters.locationsToActivate.some(
                loc => !replicatedLocations[loc.id]
            )

            if (hasUnreplicatedLocations && this.$store.getters.unMappedDrsLocations.length) {
                // Go to location mapping process
                await this.$store.dispatch('resetDrsLocationMappingState')

                this.$store.dispatch('openModal', {
                    componentPath: 'drs/service/LocationMappingIntro'
                })
                return
            }

            const activatableShopIds = this.$store.getters.activatableDrsLocationIds(shopIds)

            if (this.isDrsAuthorizationRequired && activatableShopIds.length) {
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/service/Authorization',
                    args: {
                        shopIds: cloneDumb(activatableShopIds),
                        serviceCode: this.service.code
                    }
                })
                return
            }

            try {
                if (activatableShopIds.length) {
                    await this.$store.dispatch('activateDrsService', {
                        serviceId: this.service.id,
                        shopIds: activatableShopIds,
                        level: this.service.level
                    })
                }
            } finally {
                this.status = 'idle'
                this.$store.dispatch('toggleModal', false)
                this.$nextTick(() => {
                    this.$store.dispatch('openModal', {
                        componentPath: 'drs/service/Summary',
                        args: {
                            serviceCode: this.service.code
                        }
                    })
                })
            }
        }
    },
    computed: {
        args() {
            return this.modalState.args || {}
        },
        fetchService() {
            return this.args.fetchService
        },
        modalState() {
            return this.$store.getters.modalState
        },
        allShops() {
            return this.args.allShops
        },
        selectedShopIds() {
            return this.$store.getters.getToActiveServiceShopIds
        },
        service() {
            return !this.allShops
                ? this.$store.getters.getService
                : this.args.service
        },
        serviceStatus() {
            return this.$store.getters.getServiceStatus
        },
        subscriptions() {
            return this.service.subscriptions.filter(
                el => el.status === 'inactive'
            )
        },
        isCheckedAllInactive() {
            return this.args.isCheckedAllInactive
        },
        allowSelectAll() {
            return this.service.subscriptions
                .filter(el => el.status === 'inactive')
                .every(el => el.checked)
        },
        informationClausePath() {
            return this.service.documents.find(
                v => v.name === 'Klauzula informacyjna dotycząca danych osobowych'
            )?.minioUrl
        },
        isDrs() {
            return this.service.code === SERVICE_CODE
        },
        isDrsAuthorizationRequired() {
            return this.isDrs && this.service.number_of_entities_with_subscription === 0
        },
        isActivateDisabled() {
            if (this.isDrs) {
                // For DRS service, we require the consent to be checked
                return !this.drsConsent || !this.selectedShopIds.length
            }

            if (!this.allShops) {
                return !this.selectedShopIds.length
            }

            return false
        },
        regulationPath() {
            return this.service.documents.find(({ typeCode }) => typeCode === 'R')?.minioUrl
        }
    },
    async created() {
        if (this.fetchService) {
            await this.$store.dispatch(
                'serviceFetch',
                this.args.service.id
            )
        }
        if (this.isDrs && !this.$store.getters.getServices.length) {
            await this.$store.dispatch('servicesFetch')
        }
    },
    watch: {
        serviceStatus: {
            immediate: true,
            handler(val) {
                if (
                    val === 'idle' &&
                    this.service.subscriptions &&
                    this.isCheckedAllInactive &&
                    !this.allShops
                ) {
                    this.selectAllShops(true)
                }
            }
        }
    },
    beforeDestroy() {
        if (this.isCheckedAllInactive && !this.allShops && !this.isDrs) {
            this.selectAllShops(false)
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    max-width: 100%;
}
</style>
